import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  Select,
  Table,
  Card,
  Row,
  Col,
  Button,
  Drawer,
  message,
} from "antd";

import { adminService } from "../_services/admin.service";
import { professionalAction } from "../_actions";

const { Option } = Select;

class SubCityFilter extends Component {
  state = {
    subCities: [],
    tableData: [],
    selectedCityId: "",
    add: false,
    selectedCity: "",
  };

  subCityList = () => {
    adminService.subCityList().then((res) => {
      this.setState({
        tableData: res,
      });
    });
  };
  componentDidMount() {
    this.props.dispatch(professionalAction.getCity());
    this.subCityList();
  }
  handelOpen = () => {
    this.setState({
      add: true,
    });
  };
  handelClose = () => {
    this.setState({
      add: false,
    });
  };
  createSubCity = (values) => {
    const payload = {
      city: values.city,
      sub_city: values.sub_city,
    };

    adminService
      .createSubCity(payload)
      .then((res) => {
        message.success("Sub-City created successfully");
        // Add new sub-city to state so dropdown updates
        this.setState((prev) => ({
          subCities: [...prev.subCities, res.data],
        }));
        this.form.resetFields(["newSubCity"]);
        this.handelClose();
        this.subCityList();
      })
      .catch((err) => {
        message.error(
          err.response?.data?.message || "Failed to create sub-city"
        );
      });
  };

  render() {
    const { pc_cities } = this.props && this.props.professionals;
    const { subCities, tableData } = this.state;

    const columns = [
      {
        title: "Sr.no",
        render: (_, __, index) => index + 1,
      },
      {
        title: "City",
        dataIndex: "city",
      },
      {
        title: "Sub City",
        dataIndex: "subCities",
        render: (subCities) => subCities || "-",
      },
    ];

    return (
      <>
        <Card>
          <Row
            justify="space-between"
            align="middle"
            style={{ marginBottom: 16 }}
          >
            <Col>
              <h3>City List</h3>
            </Col>
            <Col>
              <Button type="primary" onClick={this.handelOpen}>
                Add City
              </Button>
            </Col>
          </Row>
          <Table columns={columns} dataSource={tableData} rowKey="id" />
        </Card>
        <Drawer
          title="add sub cities"
          width={900}
          maskClosable={false}
          closable={false}
          onClose={this.handelClose}
          visible={this.state.add}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <div
                className="steps-action"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button onClick={this.handelClose} style={{ marginRight: 8 }}>
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          }
        >
          <Form
            layout="vertical"
            ref={(ref) => (this.form = ref)}
            onFinish={this.createSubCity}
          >
            <Row gutter={16}>
              {/* MAIN CITY */}
              <Col span={8}>
                <Form.Item
                  label="Main City"
                  name="city"
                  rules={[{ required: true, message: "Please select city" }]}
                >
                  <Select
                    placeholder="Select City"
                    onChange={(value) => {
                      this.setState({ selectedCity: value });
                      this.form.setFieldsValue({ sub_city: undefined }); // reset sub city
                    }}
                  >
                    {pc_cities?.map((c) => (
                      <Option key={c.City} value={c.City}>
                        {c.City}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {/* SUB CITY */}
              <Col span={8}>
                <Form.Item
                  label="Sub City"
                  name="sub_city"
                  rules={[
                    { required: true, message: "Please select sub city" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || value !== getFieldValue("city")) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("City and Sub City cannot be the same")
                        );
                      },
                    }),
                  ]}
                >
                  <Select
                    placeholder="Select Sub City"
                    disabled={!this.state.selectedCity}
                  >
                    {pc_cities?.map((c) => (
                      <Option
                        key={c.id}
                        value={c.id}
                        disabled={c.City === this.state.selectedCity} // 🚫 disable same city
                      >
                        {c.City}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              {/* BUTTON */}
              <Col span={8} style={{ display: "flex", alignItems: "end" }}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Create Sub-City
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedSubCityFilter = connect(mapStateToProps)(SubCityFilter);
export { connectedSubCityFilter as SubCityFilter };
